import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';
import { CIC_LOAN_TERM_REASONS_ACTION_TYPE } from 'store/system/actions';

const initialState = [];

const cicLoanTermReasonsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CIC_LOAN_TERM_REASONS_ACTION_TYPE.GET_REASONS:
        return payload || initialState;

      case CIC_LOAN_TERM_REASONS_ACTION_TYPE.CREATE_REASON:
        draft.push(payload);
        break;

      case CIC_LOAN_TERM_REASONS_ACTION_TYPE.EDIT_REASON: {
        const index = _.findIndex(draft, { cicFeeReasonId: payload.cicFeeReasonId });

        if (index !== -1) {
          draft[index] = payload;
        }

        break;
      }

      case CIC_LOAN_TERM_REASONS_ACTION_TYPE.DELETE_REASON:
        return state.filter(({ cicFeeReasonId }) => cicFeeReasonId !== payload);

      case CIC_LOAN_TERM_REASONS_ACTION_TYPE.REORDER_REASONS:
        return _.sortBy(state, ({ cicFeeReasonId }) => payload.indexOf(cicFeeReasonId));

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default cicLoanTermReasonsReducer;
